module.exports = __webpack_public_path__ + "static/media/zero_icon.c6ffeb89.svg";